import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useCartActions } from '../hooks/useCartActions';
import { formatCurrency } from "../helper/currency";

function MenuItem(props) {
  const menuItem = props.MenuItem;
  const cart = props.cart;
  const navigate = useNavigate();

  const [showVariants, setShowVariants] = useState(false);

  const isAvailable = menuItem.isActive;
  const isOffer = menuItem.offerDescription;
  const hasMultipleVariants = menuItem.variants?.length > 1;

  // Use the custom hook for all cart operations
  const {
    selectedVariant,
    quantity,
    showCartButton,
    handleAddToCart,
    handleIncreaseQuantity,
    handleDecreaseQuantity,
    handleVariantSelect,
  } = useCartActions(
    menuItem,
    menuItem.variants?.[0] || null,
    cart,
    props.setCart
  );
  useEffect(() => {
    if (selectedVariant?.availableStock === 0) {
      const firstInStockVariant = menuItem.variants?.find(v => v.availableStock > 0);
      if (firstInStockVariant) {
        handleVariantSelect(firstInStockVariant);
      }
    }
  }, [selectedVariant, menuItem]);
  const hasAnyStock = menuItem.variants?.some(v => v.availableStock > 0);
  const selectedVariantStock = selectedVariant?.availableStock || 0;
  const handleOpenDetails = () => {
    navigate(`/product/${menuItem._id}`);
  };

  const toggleVariants = (e) => {
    e.stopPropagation();
    setShowVariants(!showVariants);
  };

  return (
    <div className="col-md-4 mb-3">
      <div
        className="d-flex align-items-center list-card bg-white h-100 rounded overflow-hidden position-relative shadow-sm"
        style={{ cursor: "pointer" }}
        onClick={handleOpenDetails}
      >
        <div className="list-card-image position-relative">
          {isAvailable === 0 && <div className="card-badge">SOLD OUT</div>}
          {isOffer && <div className="offer-badge">{isOffer}</div>}
          <img
            loading="lazy"
            alt={menuItem.productName}
            src={
              menuItem.images?.length > 0
                ? `${process.env.REACT_APP_IMAGE_BASE_URL}${menuItem.images[0]}`
                : "/placeholder.png"
            }
            className="img-fluid item-img w-100"
          />
        </div>

        <div className="p-3 position-relative flex-grow-1">
          <div className="list-card-body">
            <h6 className="mb-1 text-black text-wrap">{menuItem.productName}</h6>

            {selectedVariant && (
              <small className="text-muted d-block mb-1">
                {selectedVariant.quantity} {selectedVariant.unit}
              </small>
            )}

            {!showVariants && selectedVariant && (
              <>
                {selectedVariant.offerPrice ? (
                  <>
                    <div style={{ textDecoration: 'line-through', color: 'red' }}>
                      {formatCurrency(selectedVariant.price)}
                    </div>
                    <p className="text-gray mb-2">
                      <strong className="h6 font-weight-bolder">
                        {formatCurrency(selectedVariant.offerPrice)}
                      </strong>
                      <span
                        style={{
                          color: 'green',
                          backgroundColor: '#DFF6DD',
                          marginLeft: '8px',
                          fontSize: '14px',
                          fontWeight: 'bold',
                          padding: '2px 6px',
                          borderRadius: '4px'
                        }}
                      >
                        {Math.round(
                          ((selectedVariant.price - selectedVariant.offerPrice) /
                            selectedVariant.price) *
                          100
                        )}
                        % OFF
                      </span>
                    </p>
                  </>
                ) : (
                  <p className="text-gray mb-2">
                    <strong className="h6 font-weight-bolder">
                      {formatCurrency(selectedVariant.price)}
                    </strong>
                  </p>
                )}
              </>
            )}

            {hasMultipleVariants && (
              <button
                className="btn btn-sm btn-link p-0 mb-2 text-primary"
                style={{ textDecoration: 'none', fontWeight: '600', fontSize: '14px' }}
                onClick={toggleVariants}
              >
                {showVariants ? '▲ Hide Offers' : '▼ View Offers'}
              </button>
            )}

            {hasMultipleVariants && showVariants && (
              <div className="mb-3" style={{ fontSize: '13px', color: '#333' }}>
                {menuItem.variants.map((variant) => {
                  const discount = variant.offerPrice
                    ? Math.round(((variant.price - variant.offerPrice) / variant.price) * 100)
                    : 0;

                  return (
                    <div key={variant._id} style={{ marginBottom: '4px' }}>
                      {variant.quantity} {variant.unit} –{' '}
                      {variant.offerPrice ? (
                        <>
                          <span style={{ textDecoration: 'line-through', color: 'red' }}>
                            {formatCurrency(variant.price)}
                          </span>{' '}
                          <span>{formatCurrency(variant.offerPrice)}</span>{' '}
                          <span style={{ color: 'green', fontWeight: 'bold' }}>
                            ({discount}% OFF)
                          </span>
                        </>
                      ) : (
                        <span>{formatCurrency(variant.price)}</span>
                      )}
                    </div>
                  );
                })}
              </div>
            )}
          </div>


          {!hasAnyStock || selectedVariantStock === 0 ? (
            <button
              className="btn custom-rounded-btn px-3 btn-sm text-white fw-bold"
              style={{ backgroundColor: "gray", fontWeight: "bold", cursor: "not-allowed" }}
              disabled
            >
              OUT OF STOCK
            </button>
          ) : showCartButton ? (
            <button
              className="btn custom-rounded-btn px-3 btn-sm text-white fw-bold"
              style={{ backgroundColor: "Salmon", fontWeight: "bold" }}
              onClick={handleAddToCart}
              disabled={quantity >= selectedVariantStock}
            >
              ADD
            </button>
          ) : (
            <div className="btn-group mt-2" role="group" aria-label="Basic example">
              <button
                type="button"
                className="btn-sm inc btn btn-outline-secondary"
                onClick={handleDecreaseQuantity}
              >
                <i className="feather-minus"></i>
              </button>
              <button className="btn-sm btn btn-outline-secondary" style={{ cursor: "default" }}>
                {quantity}
              </button>
              <button
                type="button"
                className="btn-sm dec btn btn-outline-secondary"
                onClick={handleIncreaseQuantity}
              >
                <i className="feather-plus"></i>
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default MenuItem;